import { MapPin, Lock } from 'lucide-react';

export const AddressField = ({ isEditing, value, onChange, savedAddress, locked }) => (
  <div className="flex items-start gap-3" data-testid="profile-address-row">
    <div className="w-8 h-8 rounded-lg bg-[#B8860B]/10 flex items-center justify-center border border-[#B8860B]/20 shrink-0">
      <MapPin className="w-4 h-4 text-[#B8860B]" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-xs text-[#B8860B] flex items-center gap-1">
        Address
        {locked && <Lock className="w-3 h-3" data-testid="profile-address-locked-icon" />}
      </p>
      {isEditing && !locked ? (
        <textarea
          data-testid="profile-address-input"
          rows={3}
          maxLength={500}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-2 py-1 text-sm font-medium text-[#004D40] border border-[#B8860B]/40 rounded focus:outline-none focus:ring-1 focus:ring-[#004D40] resize-none"
          placeholder="House / flat, street, area, city, state, PIN code"
        />
      ) : (
        <p data-testid="profile-address-value" className="text-sm font-medium text-[#004D40] whitespace-pre-line break-words">
          {savedAddress || <span className="text-gray-400 font-normal">Not added</span>}
        </p>
      )}
      {isEditing && locked && (
        <p data-testid="profile-address-locked-note" className="text-[11px] text-gray-500 mt-1">
          Verified via Aadhaar. Contact support to change it.
        </p>
      )}
    </div>
  </div>
);
